module.exports = __webpack_public_path__ + "img/_circuit_.bdd27be5.svg";